import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div class="footer bg-dark">
        <div class="container">
          {
            window.location.hostname.split('.')[0] !== "livelms"
              ?
              <span class="text-muted">{window.location.hostname.split('.')[0]}</span>
              :
              null
          }
          <span class="text-muted float-right">powered By: Lmslive.in @ 2020</span>
        </div>
      </div>
    );
  }
}
